export const metersPerNauticalMile = 1852;
